/**
 * What the admin sees in place of a download link. A file opens only after the virus scan
 * says it is clean (NFR-S5). A clean file gets no text, because it has a link.
 */
export function scanStateText(status: string): string | null {
  switch (status) {
    case 'clean':
      return null
    case 'pending':
      return 'Waiting for virus scan'
    case 'infected':
      return 'Blocked. The scan found a virus.'
    case 'failed':
      return 'Blocked. The virus scan did not complete.'
    default:
      return `Blocked. Scan state: ${status}`
  }
}
